export default function companyColumn() {
    return {
        name: 'company', label: 'Company',
        options: {
			headerAlign: 'left'
        }
    }
}